export default __webpack_public_path__ + "static/media/XVS.313df984.svg";